/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Gallery from 'react-grid-gallery';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Breadcrumb from '../../../components/Breadcrumb';
import Sidebar from '../../../components/Sidebar/AboutUs';
import s from '../AboutUs.css';

class MeetOurTeam extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    images1: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
    images2: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
    images3: PropTypes.arrayOf(
      PropTypes.shape({
        src: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        srcset: PropTypes.array,
        caption: PropTypes.string,
        thumbnailWidth: PropTypes.number,
        thumbnailHeight: PropTypes.number,
        isSelected: PropTypes.bool,
      }),
    ).isRequired,
  };

  static defaultProps = {
    images1: [
      {
        src: '/images/meet-our-team/IMG_7653_hires.jpg',
        thumbnail: '/images/meet-our-team/IMG_7653.jpg',
        thumbnailWidth: 1008,
        thumbnailHeight: 756,
        caption: 'Our Team',
        thumbnailCaption: 'Our Team',
      },
    ],
    images2: [
      {
        src: '/images/meet-our-team/IMG_7658_hires.jpg',
        thumbnail: '/images/meet-our-team/IMG_7658.jpg',
        thumbnailWidth: 756,
        thumbnailHeight: 1008,
        caption: 'Sales & Marketing Team',
        thumbnailCaption: 'Sales & Marketing Team',
      },
    ],
    images3: [
      {
        src: '/images/meet-our-team/IMG_7660_hires.jpg',
        thumbnail: '/images/meet-our-team/IMG_7660.jpg',
        thumbnailWidth: 1008,
        thumbnailHeight: 756,
        caption: 'Human Resource & Administrative Team',
        thumbnailCaption: 'Human Resource & Administrative Team',
      },
      {
        src: '/images/meet-our-team/IMG_7666_hires.jpg',
        thumbnail: '/images/meet-our-team/IMG_7666.jpg',
        thumbnailWidth: 1008,
        thumbnailHeight: 756,
        caption: 'Production & Quality Assurance Team',
        thumbnailCaption: 'Production & Quality Assurance Team',
      },
      {
        src: '/images/meet-our-team/IMG_7673_hires.jpg',
        thumbnail: '/images/meet-our-team/IMG_7673.jpg',
        thumbnailWidth: 1008,
        thumbnailHeight: 756,
        caption: 'We Are Always Ready To Serve',
        thumbnailCaption: 'We Are Always Ready To Serve',
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = {
      images1: this.props.images1,
      images2: this.props.images2,
      images3: this.props.images3,
    };
  }

  render() {
    return (
      <div className={s.root}>
        <Breadcrumb title={this.props.title} />
        <div className={s.container}>
          <Sidebar title={this.props.title} />
          <div className={s.contents}>
            <h1>
              {this.props.title}
            </h1>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images1}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={485}
              />
            </div>
            <p>
              Each and every one of our employees represent the spirit of our
              company: driven, committed and honesty. We are continuously
              ensuring not just an effective workforce, but a well-rounded,
              talented and complementary team who are always ready to serve our
              customers and community.
            </p>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images2}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={860}
              />
            </div>
            <div className={s.gallery}>
              <Gallery
                images={this.state.images3}
                backdropClosesModal
                enableImageSelection={false}
                rowHeight={485}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(MeetOurTeam);



// WEBPACK FOOTER //
// ./src/routes/about-us/meet-our-team/MeetOurTeam.js